export enum LabelPosition {
    TOP = 'TOP',
    LEFT = 'LEFT'
}



// WEBPACK FOOTER //
// ./src/models/field-builder/label-position.ts